import { config } from '../api/config';
import { getLang } from './i18n';

/*
 * Adresa politicii de confidentialitate, in limba interfetei.
 *
 * Paginile sunt statice, in public/, si sunt livrate odata cu aplicatia:
 * /privacy.html in romana, /privacy-en.html in engleza. Statice pentru ca
 * magazinele le verifica de pe un dispozitiv fara cont, deci nu au voie sa ceara
 * autentificare, si pentru ca trebuie sa ramana accesibile si cand aplicatia nu
 * porneste.
 *
 * VITE_PRIVACY_URL, daca e pusa, are prioritate si se foloseste pentru ambele
 * limbi: o instalare care isi gazduieste singura politica stie mai bine decat noi
 * ce adresa serveste.
 */
export function privacyUrl(): string {
  if (config.privacyUrl !== '') return config.privacyUrl;

  return getLang() === 'en' ? '/privacy-en.html' : '/privacy.html';
}
